<template>
	<div class="content">
		<headerTop value="1"></headerTop>
		<div class="swiperImg" :style="{backgroundImage:'url('+$index.addurl(img)+')'}"></div>
		<div class="center page-content flexbetween" :style="{animation:animation}">
			<div class="shenbaoA flex justify-between align-start">
				<div class="bg-white" style="width: 1144px;padding: 20px 0;border-radius: 10px;"
					:style="common.rightSidebar?'width: 1144px':'width: 100%'">
					<div class="box1_header" style="margin-bottom: 20px;border:none;">
						<div class="box1_header_shu"></div>
						<div class="box1_header_text">查项目库</div>
					</div>
					<div class="">
						<div class="box2_until">
							<div class="borbot" style="margin-bottom: 10px;padding: 20px 0;">
								<div class="box2_until_center">
									<div class="box2_until_left">行业&nbsp;&nbsp;:</div>
									<div class="box2_cent">
										<div :class="typeCurrent==-1?'box2_until_right cpoint bgc':'box2_until_right cpoint'"
											@click="changeAll">全部</div>
										<div v-for="(citem, cindex) in typelist.trade" :key="cindex"
											class="box2_until_right cpoint" @click="changeType(cindex)"
											:class="typeCurrent==cindex?'bgc':''">
											{{ citem.name }}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div v-if="rightlist.length" class="shenbaoright " style="width:100%">
						<div class="box5 box2_cc">
							<div class="box5_text1 text-cut">所属行业</div>
							<div class="box5_text2 text-cut">基本情况</div>
							<div class="box5_text4 text-cut">行业</div>
							<div class="box5_text2 text-cut">投资亮点</div>
							<div class="box5_text4 text-cut">轮次</div>
							<div class="box5_text4 text-cut">融资金额</div>
							<div class="box5_text5 text-cut">操作</div>
						</div>
						<div style="min-height: 550px;">
							<div v-for="(item, index) in rightlist" :key="index" class="box5">
								<div class="box5_text1">
									{{ item.name }}
								</div>
								<div class="box5_text2">
									{{ item.basic_info}}
								</div>
								<div class="box5_text4">
									{{ item.trade.name}}
								</div>
								<div class="box5_text2">{{ item.tzld}}</div>
								<div class="box5_text4">{{ item.round}}</div>
								<div class="box5_text4">{{ item.financing}}</div>
								<div class="box5_text5 text-cut cpoint" @click="todetail(item.id)">
									<div class="box2_nei">查看详情</div>
								</div>
							</div>
						</div>
						<div class="text-center" style="padding-top: 30px">
							<el-pagination background :page-size="pagesize" :hide-on-single-page="true"
								layout="prev, pager, next" @current-change="handleCurrentChange"
								:current-page="currentPage" :total="totalnum">
							</el-pagination>
						</div>
					</div>
					<div v-if="!rightlist.length" class="shenbaoright page-contents" style="width:100%">
						<div class="nodata flex justify-center align-center flex-direction">
							<div class="" style="font-size: 18px">暂无数据</div>
						</div>
					</div>
				</div>
				<div class="cright" v-if="common.rightSidebar">
					<div class="bg-white" style="width: 190px;padding: 20px 23px;border-radius: 10px;">
						<div class="box1_header" style="height: 32px;margin-bottom: 10px;">
							<div class="box1_header_shu"></div>
							<div class="box1_header_text">服务推荐</div>
						</div>
						<div class="likeone" v-for="(item,index) in advertiselist" :key="index"
							@click="tonexts(item.url)">
							<div class="oneleft">
								<img :src="item.pic | addurl" alt="">
							</div>
							<div class="oneright">
								<div class="text-cut text-center" style="font-size: 18px;width: 100%;">{{item.title}}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import headerTop from "../../components/headerTop.vue";
	export default {
		components: {
			headerTop: headerTop,
		},
		data() {
			return {
				animation: '',
				img: '',
				typeCurrent: -1,
				query: "",
				navtype: 0,
				bg: "#ff9700",
				tablist: [{
						title: "全部",
						checked: true,
						tindex: 0,
						type: 0,
					},
					{
						title: "申报公示",
						checked: false,
						tindex: 1,
						type: 1,
					},
					{
						title: "其他",
						checked: false,
						tindex: 2,
						type: 5,
					},
				],
				rightlist: [],
				type: 0,
				tindex: 0,
				totalnum: null,
				pagesize: 15,
				currentPage: 1,
				typelist: {
					trade: [],
				},
				area: '',
				city: '',
				advertiselist: [],
				common: {
					rightSidebar: false,
				},
				tradeId: '',
			};
		},
		created() {
			this.animation = 'detail .4s linear forwards';
			this.gettypelist();
		},
		methods: {
			todetail(id) {
				const {
					href
				} = this.$router.resolve({
					name: 'searchXmdetail',
					query: {
						id: id,
					}
				});
				window.open(href, '_blank');
			},
			changeAll() {
				this.currentPage = 1;
				this.typeCurrent = -1;
				this.tradeId = '';
				this.getlist();
			},
			changeType(index) {
				this.typeCurrent = index;
				this.tradeId = this.typelist.trade[index].id;
				this.currentPage = 1;
				this.getlist();
			},
			handleCurrentChange: function(currentPage) {
				this.currentPage = currentPage;
				this.getlist();
			},
			getlist() {
				let _this = this;
				_this.$api.user.getCxmkList({
					trade: _this.tradeId,
					page: _this.currentPage,
				}).then(res => {
					if (res.code == 1) {
						_this.rightlist = res.data.list.data;
						_this.totalnum = res.data.list.total;
						_this.img = res.data.background_img;
					}
				})
			},
			gettypelist() {
				let _this = this;
				_this.$api.user.getCxmkFilter({}).then(res => {
					if (res.code == 1) {
						_this.typelist = res.data;
						_this.getlist();
					}
				})
			},
			// tochoose(index, cindex, cid, name, id, pid) {
			// 	let _this = this;
			// 	for (let i in _this.typelist[index].union_type) {
			// 		_this.typelist[index].union_type[i].checked = false;
			// 	}
			// 	_this.typelist[index].union_type[cindex].checked = true;
			// 	if (pid == 0) {
			// 		_this.area = '';
			// 		_this.city = '';
			// 		_this.typelist.splice(1, 1);
			// 	} else if (pid == 20) {
			// 		_this.gettypelist(cid);
			// 		_this.city = cid;
			// 		_this.area = '';
			// 	} else {
			// 		if (cid == 'all') {
			// 			_this.area = 0;
			// 		} else {
			// 			_this.area = cid;
			// 		}
			// 	}
			// 	_this.rightlist = [];
			// 	_this.currentPage = 1;
			// 	_this.getlist();
			// 	_this.$forceUpdate();
			// },
			// getadv() {
			// 	let _this = this;
			// 	_this.$api.user.get_advertise({
			// 		type: 4
			// 	}).then(res => {
			// 		if (res.code == 1) {
			// 			_this.advertiselist = res.data;
			// 		}
			// 	})
			// }
		},

	};
</script>

<style scoped>
	.content {
		background-color: #1452DC;
		border-bottom: 1px solid #1452DC;
		/* overflow: hidden; */
	}
</style>
<style scoped lang="scss">
	.swiperImg {
		background-image: url('../../assets/page4/bg1.png');
		background-size: cover;
		background-position: center;
		position: relative;
		padding: 220px 0;
	}

	.right {
		flex-grow: 1;
		align-self: flex-start;

		.header {
			border-radius: 10px;
			margin: 20px 0;
			background-color: rgba(207, 232, 252, 0.5);
			height: 60px;

			.child {
				flex-grow: 1;
				text-align: center;
				line-height: 60px;
				color: #333;
				cursor: pointer;
				font-size: 16px;
			}

			.childs {
				flex-grow: 1;
				text-align: center;
				line-height: 50px;
				cursor: pointer;
				font-size: 16px;
				color: #1452DC;
			}

			.child:hover {
				cursor: pointer;
				color: #1452DC;
				animation: changeTab .2s linear forwards;
			}
		}
	}

	.center {
		min-height: 300px;
		margin: 0 auto 100px;
		background-color: #fff;
		padding: 80px 120px;
		border-radius: 30px;
		position: relative;
		top: -80px;

		.page {
			margin: auto;
			display: flex;
			justify-content: center;
		}

		.child {
			.img {
				width: 45%;

				img {
					width: 100%;
					height: 100%;
				}
			}

			.txt {
				width: 45%;

			}
		}
	}

	.weizhi {
		width: 1350px;
		overflow: hidden;
		margin: 0 auto;
	}

	.zuixin {
		/* height: 85px; */
		/* margin-bottom: 30px; */
	}

	.zx-line {
		display: block;
		float: left;
		width: 4px;
		height: 21px;
		background-color: #0070c0;
		margin-top: 33px;
		margin-right: 15px;
		/* margin-left: 35px; */
	}

	.newszc {
		float: left;
		font-size: 16px;
		line-height: 85px;
	}

	.shenbaoA {
		width: 1350px;
		height: auto;
		margin-bottom: 40px;
	}

	.shenbaoleft {
		width: 120px;
		height: auto;
		overflow: hidden;
		float: left;
		margin-right: 20px;
		background-color: #eee;
	}

	.shenbaoright {
		/* width: 1200px; */
		margin: 0 auto;
		height: auto;
		overflow: hidden;
	}

	.shenbaoleft li {
		width: 118px;
		height: 60px;
		line-height: 60px;
		text-align: center;
	}

	.shenbaoleft ul {
		border: 1px solid #e5e5e5;
	}

	.shenbaoleft .active1 {
		background: #fff;
		color: #0070c0;
		border-left: 2px solid #0070c0;
		width: 116px;
	}

	.shenbaoright ul {
		border: 1px solid #eee;
		padding: 0 10px;
		min-height: 742px;
		/* height: 700px; */
		/* overflow-x: hidden;
    	overflow-y: auto; */
	}

	.shenbaoright li {
		border-bottom: 1px dashed #eee;
		line-height: 36px;
		position: relative;
	}

	/*.shenbaoright li:last-child{*/
	/*    border-bottom:none;*/
	/*}*/
	.shenbaoright li span {
		position: absolute;
		top: 0;
		right: 0;
	}

	.sr_b {
		position: relative;
		margin-bottom: 30px;
	}

	.sr_btn {
		border: 1px solid #eee;
		border-radius: 5px;
		width: 175px;
		text-align: center;
		height: 32px;
		line-height: 32px;
		font-size: 14px;
		margin-top: 30px;
	}

	.fan {
		display: flex;
		position: absolute;
		right: 15px;
		top: 0;
		height: 32px;
		align-items: center;
	}

	.fan em {
		border-radius: 3px;
		margin: 0;
		border: 1px solid #eee;
		height: 18px;
		width: 32px;
		text-align: center;
		line-height: 18px;
		margin: 0 5px;
	}

	.fan p {
		margin: 0;
		line-height: 18px;
	}

	.fan span {
		display: block;
		width: 18px;
		height: 18px;
		border: 1px solid #eee;
		text-align: center;
		line-height: 18px;
		border-radius: 3px;
	}

	.danhang {
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.nodata {
		border: 1px solid #eee;
		padding: 10px;
		min-height: 742px;
	}

	.box2_until_center {
		display: flex;
	}

	.box2_until_left {
		font-size: 14px;
		color: #959595;
		width: 55px;
		line-height: 28px;
	}

	.box2_until_right {
		height: 28px;
		font-size: 14px;
		line-height: 28px;
		padding: 0 8px;
		color: #4e4e4e;
		margin-bottom: 10px;
		margin: 0 10px;
	}

	.bgc {
		background-color: #0070c0;
		color: #fff;
	}

	.borbot {
		border-bottom: 1px solid #eee;
	}

	.box2_cent {
		display: flex;
		width: 93%;
		flex-wrap: wrap;
		min-height: 38px;
	}

	.sty {
		color: #ffffff;
		background: #0070c0;
	}


	.oneleft {
		width: 99px;
		height: 99px;
	}

	.oneleft img {
		width: 99px;
		height: 99px;
		border-radius: 10px;
	}

	.oneright {
		margin-top: 10px;
		width: 77%;
		display: flex;
		justify-content: center;
		align-items: flex-start;
		flex-direction: column;
	}

	.oneright p {
		font-size: 14px;
		color: #292a2d;
		font-weight: 400;
		padding-bottom: 2px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		width: 214px;
	}

	.oneright span {
		display: inline-block;
		padding: 2px 8px;
		font-size: 12px;
		color: #fff;
		font-weight: 400;
		background: #36a6f7;
		border-radius: 2px;
	}

	.likeone {
		height: auto;
		cursor: pointer;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		margin-bottom: 25px;
	}

	.likeone:last-child {
		margin-bottom: 0px;
	}

	.box1_header {
		display: flex;
		/* height: 55px; */
		align-items: center;
		/* border-bottom: 1px solid #eee; */
	}

	.box1_header_text {
		font-size: 20px;
		color: #111111;
		font-weight: 600;
		margin-left: 10px;
	}

	.box1_header_shu {
		width: 4px;
		height: 21px;
		background-color: #0070c0;
	}

	.cright {
		position: sticky;
		/* top: 166px; */
		top: 20px;
	}



	.box5 {
		width: 100%;
		display: flex;
		min-height: 50px;
		border-bottom: 1px solid #f1f1f1;
	}

	.box5_text1 {
		width: 20%;
		display: flex;
		align-items: center;
		border-right: 1px solid #f1f1f1;
		border-left: 1px solid #f1f1f1;
		padding: 5px;
		justify-content: center;
	}

	.box5_text2 {
		width: 27%;
		display: flex;
		align-items: center;
		justify-content: center;
		border-right: 1px solid #f1f1f1;
		padding: 5px;
	}

	.box5_text4 {
		width: 8%;
		display: flex;
		align-items: center;
		justify-content: center;
		border-right: 1px solid #f1f1f1;
		padding: 5px;
	}

	.box5_text5 {
		width: 10%;
		display: flex;
		align-items: center;
		justify-content: center;
		border-right: 1px solid #f1f1f1;
		padding: 5px;
	}

	.box5_text3 {
		width: 12%;
		display: flex;
		align-items: center;
		justify-content: center;
		border-right: 1px solid #f1f1f1;
		padding: 5px;
	}

	.sty {
		color: #ffffff;
		background: #0070c0;
	}

	.box2_cc {
		color: #ffffff;
		background-color: #0070c0;
	}

	.box2_nei {
		/* width: 95px; */
		height: 30px;
		padding: 0 15px;
		/* background-color: #ff6c00; */
		background-color: #0160a3;
		color: #ffffff;
		border-radius: 7px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
</style>


// WEBPACK FOOTER //
// searchXm.vue?5d1bd427